import { useNavigate } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { browserStorage } from '../../utils/browserStorage.util';

interface IUseRedirectToStoredPageReturn {
  navigateToStoredPage: () => void;
}

export const useRedirectToStoredPage = (): IUseRedirectToStoredPageReturn => {
  const navigate = useNavigate();

  const navigateToStoredPage = () => {
    const storedPagePath = browserStorage.getItem({
      storageType: 'sessionStorage',
      itemKey: 'storedPageForRedirection',
    });

    if (!storedPagePath) {
      navigate(pageInfo.homePage.path, { state: { loginFinished: true }, replace: true });
      return;
    }

    navigate(storedPagePath, { state: { loginFinished: true }, replace: true });
  };

  return { navigateToStoredPage };
};
